import PdfRenderer from "@features/session/components/PdfRenderer";
import Box from "@memorang/ui/src/components/Box";
import CustomNavigationBar from "components/CustomAppbar";
import { useLocalSearchParams } from "expo-router";

const source = {
	uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/jbjs-assets/pdfs/chapman.pdf",
	cache: true,
};

const Citations = () => {
	const { pageNumber } = useLocalSearchParams<{ pageNumber: string }>();

	return (
		<>
			<CustomNavigationBar
				options={{
					headerTitle: "Citation source",
					headerRight: () => null,
				}}
				back
			/>
			<Box flex={1} height="100%">
				<PdfRenderer pageNumber={Number(pageNumber)} source={source} />
			</Box>
		</>
	);
};

export default Citations;
